import {GprcError, GrpcErrorHandler} from '@/services/api-requests/grpc-request-ts';

export const ignoreVP39 = <Response extends object>(defaultValue: Response) => {
    return (error: GprcError) => {
        if (error.errorCode === 'VP00039') {
            return Promise.resolve({
                response: defaultValue,
            });
        }
        throw error;
    };
};

/**
 * Combines multiple error handlers in a OR fashion. If one of the handlers returns and does not throw, the value
 * will be returned to handle the error. If all handlers throw, we rethrow the original error
 * @param handlers all the handlers to try, in order. The first to return will have priority of the others
 */
export function combineHandlers<Response extends object>(handlers: Array<GrpcErrorHandler<Response>>): GrpcErrorHandler<Response> {
    return (error: GprcError) => {
        for (const handler of handlers) {
            try {
                return handler(error);
            }
            catch (error) {
                /* Do nothing, we try the next handler */
            }
        }
        throw error;
    };
}
